'use client'

import { useEffect, useState } from 'react'
import { getUserId } from '@/app/lib/actions'
import ProductList from '../products/ProductList'

export default function VendorProductsSection() {
  const [userId, setUserId] = useState<string | null>(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    async function fetchUserId() {
      const id = await getUserId()
      setUserId(id)
      setLoading(false)
    }

    fetchUserId()
  }, [])

  if (loading) return <p>Carregando...</p>

  if (!userId) {
    return (
      <p className="text-center text-gray-600">
        🔐 Você precisa estar logado para ver seus produtos.
      </p>
    )
  }

  return (
    <div>
      <h2 className="text-xl font-semibold mb-4">Seus Produtos Cadastrados</h2>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        <ProductList vendor_id={userId} isManageMode={true} />
      </div>
    </div>
  )
}
